<style lang="scss" scoped="">
  $table-background-color: #dfe6ec;
  $table-background-color-tint: #eee;
  .product-detail-list {
    margin: 20px 0;
    table-layout: fixed;
    /*margin-top: 20px;*/
    text-align: center;
    border-collapse: collapse;
    font-size: 12px;

    > tbody > tr > td {
      padding: 5px;
      border: 1px solid $table-background-color;
    }

    .t-head {
      background: #eaf2f8;
      color: #1f2d3d;
      font-weight: bold;
    }

    &.is-top {
      > tbody > tr > td {
        border-bottom: 0;
      }
    }

    &.is-tint {
      > tbody > tr > td {
        border: 1px solid #d6d6d6;
      }

      .t-head {
        background: $table-background-color-tint;
      }

      &.is-top {
        > tbody > tr > td {
          border-bottom: 0;
        }
      }
    }
  }

  .bg-white {
    background: #fff;
  }

  .bg-red {
    background: #f70f0f;
  }

  .color-red {
    color: red;
  }

  .page-main-body {
    .oms-row {
      margin-bottom: 5px;
    }
  }

  .goods-histories {
    border: 1px solid #dfe6ec;
    border-top: 0;
    padding: 10px 20px;
    margin-bottom: 10px;

    h3 {
      margin: 0;
      font-weight: 500;
      font-size: 18px;
      text-align: center;
    }

    .h-item {
      padding-bottom: 20px;
    }
  }
</style>
<template>
  <div>
    <div v-if="isShowBaseInfo">
      <el-row class="page-main-body padding" style="margin-bottom:0">
        <el-col :span="12">
          <oms-row label="货主订单号">
            <span>{{currentOrder.orderNo}}</span>
          </oms-row>
          <oms-row label="货主">
            {{ currentOrder.upstreamOrgName }}
          </oms-row>
        </el-col>
        <el-col :span="12">
          <oms-row label="业务类型">
            <dict :dict-group="'bspBizType'" :dict-key="currentOrder.bizType"></dict>
          </oms-row>
          <oms-row :label="$formatOrderType(type)">
            {{currentOrder.downstreamOrgName}}
          </oms-row>
        </el-col>
      </el-row>
      <hr class="hr"/>
    </div>
    <div v-loading="doing">
      <div :class="!isShowBaseInfo ? '' : 'empty-info'" v-if="!goodsDetails.length">无收货信息</div>
      <div v-else>
        <div v-for="item in goodsDetails" :key="item.id">
          <table class="product-detail-list" width="100%">
            <tbody>
            <tr>
              <td colspan="1" class="t-head">名称</td>
              <td colspan="6">
                <div>
                  {{item.goodsName}}
                </div>
                <div class="f-grey">
                  {{ item.specification }}
                </div>
              </td>
              <td colspan="1" class="t-head">生产厂商</td>
              <td colspan="6">{{item.factoryName}}</td>
            </tr>
            <tr>
              <td colspan="2" class="t-head">批号</td>
              <td colspan="2" class="t-head">生产日期</td>
              <td colspan="2" class="t-head">有效期</td>
              <td colspan="4" class="t-head">实收数量</td>
              <td colspan="4" class="t-head">拒收数量</td>
            </tr>
            <tr v-for="batchNumber in item.batchNumbers" :key="batchNumber.id"
                v-if="item.batchNumbers && item.batchNumbers.length > 0">
              <td colspan="2">
                {{ batchNumber.batchNumber }}
              </td>
              <td colspan="2">{{ batchNumber.productionDate | date }}</td>
              <td colspan="2">{{ batchNumber.expirationDate | date }}</td>
              <td colspan="4">
                {{batchNumber.aggregateQuantity || ''}}
              </td>
              <td colspan="4">
                {{batchNumber.refuseCount || ''}}
              </td>
            </tr>
            <tr>
              <td colspan="2" class="t-head">实收合计</td>
              <td colspan="5">
                {{ getTotalNumber(item) || '' }}
              </td>
              <td colspan="2" class="t-head">拒收合计</td>
              <td colspan="5">
                {{ getRefuseTotalNumber(item) || '' }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {BSPOrder} from '@/resources';

  export default {
    props: {
      currentOrder: {
        required: true,
        type: Object,
        default: function () {
          return {};
        }
      },
      index: {
        type: Number,
        default: -1
      },
      isFormReceipt: Boolean,
      isShowBaseInfo: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        goodsDetails: [],
        doing: false,
        loadingHistory: false
      };
    },
    computed: {
      type() {
        return this.$route.meta.type;
      }
    },
    watch: {
      index(val) {
        if (val !== 3) return;
        this.goodsDetails = [];
        if (!this.currentOrder.details) return;
        this.getGoodsDetails();
      }
    },
    methods: {
      getGoodsDetails() {
        if (!this.currentOrder.id) return;
        this.doing = true;
        BSPOrder.queryReceiptDetail(this.currentOrder.id).then(res => {
          this.doing = false;
          if (!res.data.length) return;
          let ary = [];
          let set = new Set();
          this.currentOrder && this.currentOrder.details.forEach(i => set.add(i.goodsId));
          [...set].forEach(i => {
            let children = this.currentOrder.details.filter(g => g.goodsId === i);
            // 拷贝一份订单详情，再累加其值
            children = JSON.parse(JSON.stringify(children));
            if (children.length === 1) {
              ary.push(children[0]);
            } else {
              let amount = 0;
              children.forEach(i => (amount += i.amount));
              children[0].amount = amount;
              ary.push(children[0]);
            }
          });
          ary = JSON.parse(JSON.stringify(ary));
          ary.forEach(i => {
            i.reHistories = [];
            i.showHistories = false;
          });
          this.goodsDetails = ary;
          this.goodsDetails.forEach(i => {
            i.batchNumbers = res.data.filter(f => f.goodsId === i.goodsId);
            if (i.batchNumbers.length) {
              i.factoryName = i.batchNumbers[0].factoryName;
            }
          });
        }).catch(() => {
          this.doing = false;
        })
      },
      getTotalNumber(item) {
        if (!item.batchNumbers) return 0;
        let num = 0;
        item.batchNumbers.forEach(b => {
          num += b.aggregateQuantity;
        });
        return num;
      },
      getRefuseTotalNumber (item) {
        if (!item.batchNumbers) return 0;
        let num = 0;
        item.batchNumbers.forEach(b => {
          num += b.refuseCount;
        });
        return num;
      }
    }
  };
</script>
